import { render } from "./TasksConfigModal.vue?vue&type=template&id=0f2b154a&scoped=true&ts=true"
import script from "./TasksConfigModal.vue?vue&type=script&lang=ts"
export * from "./TasksConfigModal.vue?vue&type=script&lang=ts"

import "./TasksConfigModal.vue?vue&type=style&index=0&id=0f2b154a&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2b154a"]])

export default __exports__